/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InsightList = {
  readonly uuid: string
  /**
   * * `FEATURES_COUNTS` - Features
   * * `FEATURES_CATEGORIES` - Features Categories
   * * `LABEL` - Label
   * * `LABEL_REASON` - Label Reason
   * * `DISTRIBUTION` - Distribution
   * * `PREDICTIONS_PER_WORKFLOW` - Predictions Per Workflow
   * * `FEATURE_COMPARISON` - Feature Comparison
   */
  type: InsightList.type
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `SKIPPED` - Skipped
   */
  status?: InsightList.status
  skip_reason?: string | null
}
export namespace InsightList {
  /**
   * * `FEATURES_COUNTS` - Features
   * * `FEATURES_CATEGORIES` - Features Categories
   * * `LABEL` - Label
   * * `LABEL_REASON` - Label Reason
   * * `DISTRIBUTION` - Distribution
   * * `PREDICTIONS_PER_WORKFLOW` - Predictions Per Workflow
   * * `FEATURE_COMPARISON` - Feature Comparison
   */
  export enum type {
    FEATURES_COUNTS = "FEATURES_COUNTS",
    FEATURES_CATEGORIES = "FEATURES_CATEGORIES",
    LABEL = "LABEL",
    LABEL_REASON = "LABEL_REASON",
    DISTRIBUTION = "DISTRIBUTION",
    PREDICTIONS_PER_WORKFLOW = "PREDICTIONS_PER_WORKFLOW",
    PREDICTIONS_PER_MODEL = "PREDICTIONS_PER_MODEL",
    FEATURE_COMPARISON = "FEATURE_COMPARISON",
    LABEL_TIME_COUNT = "LABEL_TIME_COUNT",
    FEATURE_CORRELATION = "FEATURE_CORRELATION",
    FEATURES_PROFILING = "FEATURES_PROFILING",
    WORKFLOW_NODE_PERCENTAGES = "WORKFLOW_NODE_PERCENTAGES",
    LEGACY_SIMULATION_REPORT = "LEGACY_SIMULATION_REPORT",
  }
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `SKIPPED` - Skipped
   */
  export enum status {
    PENDING = "PENDING",
    RUNNING = "RUNNING",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
    SKIPPED = "SKIPPED",
  }
}
